import React from 'react';
import Input from '../../../../form/input/Input';
import { ArcherContext } from '../../../context/ArcherContext';

const ArcherInitialParameters = (props) => {

    const {
        setCountry, setSize, setHeatingType
    } = React.useContext(ArcherContext);

    return (
        <div className='calculator__input-wrapper_archer'>
            <Input
                label={props.translations.countryLabel}
                id='country'
                onChange={setCountry}
            >
                {props.countryTable.map((option, i) => <option key={`${i}-${option.country}`}
                    selected={1 === 0}
                    option={option.country}>{option.country}</option>)}
            </Input>
            <Input
                label={props.translations.storeSizeLabel}
                id='store-size'
                onChange={setSize}
                tooltipContent={props.translations.storeSizeTooltip}
            >
                {props.sizes.map((option, i) => <option key={`${i}-${option.value.contentTypeID}`}
                    selected={i === 0}
                    option={option.value.size}>{option.value.size}</option>)}
            </Input>

            <Input
                label={props.translations.comparisonLabel}
                id='heating-type'
                onChange={setHeatingType}
            >
                {props.heatingTypes.map((option, i) => <option key={`${i}-${option.value.name}`}
                    selected={i === 0}
                    option={option.value.name}>{option.value.name}</option>)}
            </Input>

        </div>
    );
};

export default ArcherInitialParameters;
